import { Fragment } from 'react'
import { Translate, I18n } from 'react-redux-i18n'
import Dashboard from 'endpoints/dashboard'
import Time from 'components/time'
import Wait from 'components/wait'

class LogRow extends React.Component {
  constructor() {
    super();
    this.state = { open: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }

  render() {
    let { log } = this.props;
    let rows, toggleType, toggleIcon, onClick;
    if(this.state.open) {
      rows = (
        <tr >
          <td colSpan="4">
            <ul className="list-group list-group-flush">
              {log.logs.map((logItem, i) => (
                <li key={i} className="list-group-item">
                  <Translate value={`enums.log_status.${logItem.status.toLowerCase()}`} className={`log-status log-status--${logItem.status.toLowerCase()}`} />
                  <span className="d-block my-1">{logItem.message}</span>
                  <span className="text-muted small">{logItem.place}</span>
                </li>
              ))}
            </ul>
          </td>
        </tr>
      );
      toggleType = 'angle-up';
    } else {
      toggleType = 'angle-down';
    }

    if(log.logs.length > 0) {
      onClick = this.toggle;
      toggleIcon = (
        <a href="#" className={`fa fa-${toggleType} fa-2x`} onClick={this.toggle} />
      );
    }

    return (
      <Fragment>
        <tr onClick={onClick} className={onClick ? 'clickable' : ''}>
          <td>
            <Translate value={`enums.permission.${log.step.toLowerCase()}`} className="font-weight-bold" />
          </td>
          <td className="font-italic">{log.file}</td>
          <td className="text-center">
            <label className={`log-status_icon log-status_icon--${log.status}`}>
              {log.logs.length}
            </label>
          </td>
          <td>{toggleIcon}</td>
        </tr>
        {rows}
      </Fragment>
    );
  }
}

export default class extends React.Component {
  constructor() {
    super();
    this.state = { logs: null, startedAt: null };
    this.exportXlsx = this.exportXlsx.bind(this);
  }

  componentDidMount() {
    Dashboard.getDraftLogs().then(({ logs, startedAt }) => this.setState({ logs, startedAt }));
  }

  exportXlsx(e) {
    e.preventDefault();
    let rows = this.state.logs.reduce((acc, log) => {
      if(log.logs.length === 0) {
        acc.push([
          I18n.t(`enums.permission.${log.step.toLowerCase()}`),
          log.file,
          I18n.t(`enums.log_status.${log.status.toLowerCase()}`),
          '',
          ''
        ]);
      } else {
        log.logs.forEach(logItem => {
          acc.push([
            I18n.t(`enums.permission.${log.step.toLowerCase()}`),
            log.file,
            I18n.t(`enums.log_status.${logItem.status.toLowerCase()}`),
            logItem.message,
            logItem.place
          ]);
        });
      }
      return acc;
    }, [[
      I18n.t('home.logs.xlsx.step'),
      I18n.t('home.logs.xlsx.file'),
      I18n.t('home.logs.xlsx.status'),
      I18n.t('home.logs.xlsx.message'),
      I18n.t('home.logs.xlsx.place')
    ]]);

    import('./save-xlsx').then(({ default: saveXlsx }) => {
      saveXlsx('processing-log', rows, [25, 25, 15, 50, 20]);
    });
  }

  render() {
    let content, footer;
    if(this.state.logs === null) {
      content = (
        <Fragment>
          <Wait />
          <h5 className="my-2 text-center"><Translate value="home.logs.processing" /></h5>
        </Fragment>
      );
    } else {
      let logs = this.state.logs.map(log => <LogRow key={log.id} log={log} />);
      content = (
        <table className="table">
          <colgroup>
            <col width="35%" />
            <col width="40%" />
            <col width="20%" />
            <col width="5%" />
          </colgroup>
          <thead>
            <tr>
              <th><Translate value="home.logs.columns.step" /></th>
              <th><Translate value="home.logs.columns.file" /></th>
              <th className="text-center"><Translate value="home.logs.columns.logs" /></th>
              <th />
            </tr>
          </thead>
          <tbody>{logs}</tbody>
        </table>
      );
      footer = (
        <div className="modal-footer">
          <a href="#" className="btn btn-primary" onClick={this.exportXlsx}>
            <Translate value="home.logs.download" />
          </a>
        </div>
      );
    }

    return (
      <div>
        <div className="modal fade show d-block">
          <div className="modal-dialog modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <Translate value="home.logs.header" />
                  <Time value={this.state.startedAt} className="d-block small mt-1" />
                </h5>
                <button type="button" className="close" onClick={this.props.onClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">{content}</div>
              {footer}
            </div>
          </div>
        </div>
        <div className="modal-backdrop show fade" />
      </div>
    );
  }
}
